import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LoadingPage from './LoadingPage';

/**
 * A `LoadingPage` that only paints if it is still mounted after `delayMs`.
 *
 * Used as the lazy-route `<Suspense>` fallback. A route chunk that is already
 * cached resolves in a few milliseconds, and painting a full-viewport spinner
 * for those few milliseconds -- between the boot loader and the view's own
 * loader -- reads as a flicker rather than as progress. Deferring means a warm
 * chunk shows nothing at all, and only a genuinely slow download gets a spinner.
 */
const DeferredLoadingPage = ({ delayMs = 150 }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delayMs);
    return () => clearTimeout(timer);
  }, [delayMs]);

  return show ? <LoadingPage /> : null;
};

DeferredLoadingPage.propTypes = {
  delayMs: PropTypes.number,
};

export default DeferredLoadingPage;
